module.exports = __webpack_public_path__ + "static/media/newsletter-icon.7e8c3d91.svg";